import { atom, RecoilState } from 'recoil';
/** 章节速览-回顾选中ID */
const reviewIdState = atom({
  key: 'qaRelated/reviewId',
  default: -1,
});
const titleGeneratorInfoState = atom({
  key: 'qaRelated/titleGeneratorInfo',
  default: undefined,
});

/** 问答回顾-回顾选中ID */
const gistQAReviewIdState = atom({
  key: 'qaRelated/gistQAReviewId',
  default: '',
});

/** 待办事项-回顾选中ID */
const toDoReIdState = atom({
  key: 'qaRelated/toDoReId',
  default: -1,
});

const pptReViewInfoStatus: RecoilState<any> = atom({
  key: 'qaRelated/pptReViewInfo',
  default: undefined,
});

export {
  reviewIdState,
  titleGeneratorInfoState,
  gistQAReviewIdState,
  toDoReIdState,
  pptReViewInfoStatus,
};
